import { useEffect } from 'react';

const useSEO = ({ title, description, canonical, robots, ogTitle, ogDescription, ogUrl, ogImage, ogType }) => {
  useEffect(() => {
    if (title) document.title = title;
    const setMeta = (attr, attrVal, content) => {
      let el = document.querySelector(`meta[${attr}="${attrVal}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, attrVal);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };
    if (description) setMeta('name', 'description', description);
    if (robots) setMeta('name', 'robots', robots);
    if (ogTitle) setMeta('property', 'og:title', ogTitle);
    if (ogDescription) setMeta('property', 'og:description', ogDescription);
    if (ogUrl) setMeta('property', 'og:url', ogUrl);
    if (ogImage) setMeta('property', 'og:image', ogImage);
    if (ogType) setMeta('property', 'og:type', ogType);
    if (canonical) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) { link = document.createElement('link'); link.setAttribute('rel', 'canonical'); document.head.appendChild(link); }
      link.setAttribute('href', canonical);
    }
  }, [title, description, canonical, robots, ogTitle, ogDescription, ogUrl, ogImage, ogType]);
};

export default useSEO;
